import { SIZE, Stack, Text } from '@quinyx/ui';

import { withSupportLayout } from '../../layouts/support';
import { useTranslate } from '../../hooks/translate';

const Support = () => {
  const { t } = useTranslate();

  return (
    <Stack spacing={SIZE.M}>
      <Text variant="headlineHeavy" color="SurfaceOnSurface">
        {t('common.chooseActionInSidebar')}
      </Text>
      <Text>{t('support.description')}</Text>
    </Stack>
  );
};

export default withSupportLayout(Support);
